import request from "@/utils/request";

// 初始化
export function findAppAlbumPhotoInfoApi(data) {
  return request({
    url: "web/appAlbumPhotoInfo/listSelectData",
    method: "post",
    data
  });
}

// 列表
export function loadAppAlbumPhotoInfoApi(data) {
  return request({
    url: "web/appAlbumPhotoInfo/listByPage",
    method: "post",
    data
  });
}

// 导出
export function exportAppAlbumPhotoInfoApi(data) {
  return request({
    url: "web/appAlbumPhotoInfo/exportByPage",
    method: "post",
    data
  });
}

// 取消活动报告关联
export function updatePhotoCancelCameraAndReportRelationApi(data) {
  return request({
    url: "web/appAlbumPhotoInfo/updatePhotoCancelCameraAndReportRelation",
    method: "post",
    data
  });
}

// 审核时活动报告附件删除
export function updateReportAttAndPhotoRemoveRelationApi(data) {
  return request({
    url: "web/appAlbumPhotoInfo/updateReportAttAndPhotoRemoveRelation",
    method: "post",
    data
  });
}

// 旋转照片
export function rotatePhotoByConditionApi(data) {
  return request({
    url: "web/appAlbumPhotoInfo/rotatePhotoByCondition",
    method: "post",
    data
  });
}